<script setup lang="ts">
import SmallModel from "@/components/Interface/Modal/ModelSizes/SmallModel.vue";
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import {useGameStore} from "@/stores/gameStore.ts";
import Backend from '@/models/backend.ts'
import { computed, ref } from 'vue'
import { usePQAStore } from '@/stores/PQAStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()
const pqaStore = usePQAStore()
const backend = new Backend()

const targetPQAId = ref(0)

const pqaOptions = computed(() =>
  [...pqaStore.queues.values()]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((pqa) => ({ value: pqa.id, label: pqa.name }))
)

const selectAndSubmit = (val: string | number) => {
  targetPQAId.value = Number(val)
  setPQA()
}

// Handle form submission
const setPQA = () => {
  backend.planetSetPQA(gameStore.modalData,targetPQAId.value).then(() => {
    gameStore.modalType=''
  })
}

</script>
<template>
  <SmallModel :title="t('modals.setProductionQueue.title')">
    <div class="p-2">
      <div class="text-subtext pb-2">{{ t('modals.setProductionQueue.description') }}</div>
      <div>
        <FormSelect
          :modelValue="targetPQAId"
          @update:modelValue="selectAndSubmit"
          :options="pqaOptions"
        />
      </div>
    </div>
  </SmallModel>
</template>



<style scoped lang="scss">

</style>